export default __webpack_public_path__ + "static/media/icon_finish.aa5e016b.svg";